import xlsx from "xlsx";

///This is the pride and joy you need to call this before you can use the rest
//be sure to call with async await
export const xlsxToWorkbook = file => new Promise(resolve => {
  const reader = new FileReader();
  reader.onload = () => resolve(xlsx.read(new Uint8Array(reader.result), { type: "array", cellDates: true }));
  reader.readAsArrayBuffer(file);
});

export const workbookToJSON = workbook => workbook.SheetNames.map(sheetName =>
  worksheetToJSON(workbook.Sheets[sheetName])
);

export const worksheetToJSON = worksheet => xlsx.utils.sheet_to_json(
  worksheet,
  { raw: true, header: 1 }
);

export const workbookToRowCount = workbook => workbook.SheetNames.map(sheetName =>
  worksheetToRowCount(workbook.Sheets[sheetName])
);

export const worksheetToRowCount = worksheet => xlsx.utils.sheet_to_json(
  worksheet,
  { raw: true }
).length;

export const workbookToworksheetByIndex = ({ workbook, index }) => workbook.Sheets[workbook.SheetNames[index]];

export const workSheetToColumnHeaders = worksheet => formatColumnHeaders(worksheetToJSON(worksheet)[0] || []);

//This may look weird, but the Array that being mapped has undefined indices removed entirely for performance reasons, in this instance we want to restore them
const formatColumnHeaders = rawColumnHeaders => Array.from(Array(rawColumnHeaders.length)).map((_, index) => rawColumnHeaders[index] ? rawColumnHeaders[index] : "");

//Shamelessly copied from internet https://stackoverflow.com/a/182924
export const columnIndexToColumnLetter = index => {
  let dividend = index + 1;
  let columnName = "";
  let modulo;
  while (0 < dividend) {
    modulo = (dividend - 1) % 26;
    columnName = String.fromCharCode(65 + modulo).toString() + columnName;
    dividend = parseInt((dividend - modulo) / 26);
  }
  return columnName;
};